import { defineMessages } from '@atlassian/jira-intl';

export default defineMessages({
	key: {
		id: 'business-list.controllers.get-issue-fields.constants.key',
		defaultMessage: 'Key',
		description: '"Key" is the user-displayed identifier field for an issue (the issue key)',
	},
	comments: {
		id: 'business-list.controllers.get-issue-fields.constants.comments',
		defaultMessage: 'Comments',
		description:
			'"Comments" refers to the field within an issue that contains the associated comments',
	},
	confluencePages: {
		id: 'business-list.controllers.get-issue-fields.constants.confluence-pages',
		defaultMessage: 'Confluence pages',
		description:
			'The "Confluence pages" field stores the linked Confluence pages associated with an issue.',
	},
});
